import api from "api";
import { supportApiBase } from "api/constants";
import { useMutation } from "react-query";

export type ExerciseState = "draft" | "in_review" | "approved" | "rejected";

export interface Vars {
  id: number;
  state: ExerciseState;
}

export const usePutExerciseState = () =>
  useMutation((data: Vars) => {
    // @ts-ignore
    return api("PUT /exercises/{id}/state", {
      params: [data.id],
      data: {
        state: data.state,
      },
      root: supportApiBase,
    });
  });
